/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface avatarMaleProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const avatarMale: React.FC<avatarMaleProps> = ({size, ...props}) => (
  <svg viewBox="0 0 60 60" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M45,34.31c-.22,1.65-1.22,2.85-2.33,2.85a2.84,2.84,0,0,1-1.1-.22A12,12,0,0,1,30,47.21c-5.93,0-10.51-4.51-11.57-10.24a2.83,2.83,0,0,1-1,.19c-1.13,0-2.17-1.33-2.35-2.85A2.34,2.34,0,0,1,17,31.51a19.48,19.48,0,0,1-.63-5c0-2.77.39-5.12,2.18-5.52,2-.45,4.46,1.42,4.75-.05s-3.47-1.15-5.2-3.19c-1.92-2.25.64-7.15,1.79-7.15s.43,2.31,4.53,2.31h8.39A10.94,10.94,0,0,1,43.63,24c0,4.45-.28,6.68-.57,7.54A2.32,2.32,0,0,1,45,34.31ZM60,0V60H0V0H60ZM45.75,53.14a28,28,0,1,0-31.5,0,22.75,22.75,0,0,1,10-5.64A11,11,0,0,0,30,48.89a11,11,0,0,0,5.71-1.4A22.75,22.75,0,0,1,45.75,53.14ZM44.61,3.8h0ZM13.26,5.1h0ZM5.88,12.16h0Zm.22,36,0,0-.06-.09Zm9.34,8.07-.15-.08.08.07ZM46.74,54.9l.08-.08-.15.1Zm7.39-7.11-.08.11.07-.06ZM53.9,11.87h0Z"
    />
  </svg>
);
avatarMale.displayName = 'avatarMale';
export default avatarMale;
/* tslint:enable */
/* eslint-enable */
